import type { MenuProps } from 'antd';
import type { ReactNode } from 'react';

type MenuItem = NonNullable<MenuProps['items']>[number];

export type SidebarItem = {
  key: string;
  label: string;
  icon?: ReactNode;
};

export type SidebarSection = {
  key: string;
  label: string;
  icon: ReactNode;
  children: SidebarItem[];
};

export const buildSidebarMenuItems = (
  sections: SidebarSection[],
  dashboardItem?: SidebarItem,
  popupClassName?: string,
): MenuItem[] => {
  const items: MenuItem[] = [];

  if (dashboardItem) {
    items.push({
      key: dashboardItem.key,
      icon: dashboardItem.icon,
      label: dashboardItem.label,
      title: dashboardItem.label,
    } as MenuItem);
    items.push({ type: 'divider' } as MenuItem);
  }

  items.push(
    ...sections.map((section) => ({
      key: section.key,
      icon: section.icon,
      label: section.label,
      title: section.label,
      popupClassName,
      children: section.children.map((child) => ({
        key: child.key,
        icon: child.icon,
        label: child.label,
        title: child.label,
      })),
    }) as MenuItem),
  );

  return items;
};
